import certifications from "./certifications";

const certificationService = [{
    matcher: 'processingInbox/certifications',
    reply: config => {
        return [200, certifications];
    }
},{
   matcher: /certifications\/(.*)/,
    reply: config => {
        const id = /certifications\/(.*)/.exec(config.url)[1];
        const data = certifications.find(certification => certification.id === id);
        return [200, data];
    }
}]

export default certificationService;